import { config } from './config';

/*
 * Because of our deploy model, we can only get the public path on runtime,
 * So we need to override webpack public path in our application entry file on runtime.
 * Please refer to https://webpack.js.org/guides/public-path/
 */
if (!config.isDev) {
  // eslint-disable-next-line
  __webpack_public_path__ = `${window.utag_data?.hsbc_chat_assistant_config?.domain}/`;
}
